import { useEffect } from "react";
import { alphartisApiAxios } from "./axios";
import { config } from "./configuration";

const styleGreen = "color:white; background:#28d79f";
const stylePink = "color:white; background:#B14D9A";
const styleRed = "color:white; background:#d36a6a";
const styleOrange = "color:white; background:#f48042";

export function useLogVersions() {
  const VERSION = config.version;
  const commitHash = config.commitHash;

  useEffect(() => {
    (async () => {
      try {
        const response = await alphartisApiAxios.get("/version");

        console.log(
          `%c  ui %c alphartis %c v${VERSION} %c ${commitHash.substring(0, 8)} `,
          stylePink,
          styleGreen,
          styleOrange,
          styleRed,
        );

        console.log(
          `%c api %c alphartis %c v${response.data?.version} %c ${response.data?.commitHash} `,
          stylePink,
          styleGreen,
          styleOrange,
          styleRed,
        );
      } catch (error) {
        console.error("Error fetching version information:", error);
      }
    })();
  }, [VERSION, commitHash]);
}
